import { UPDATE_CART, UPDATE_CART_ITEM, OVERRIDE_CART_TOTAL } from '../';
import DataProvider from '../../../../provider';
import { show } from './message';
import { incrementPendingRequestCounter, decrementPendingRequestCounter, updateStatus } from './index';
import { SellingAreaStatus } from '../';
import { translateError } from '../../utils/backendErrors';

export const update = (cart, walletBalance?: any, corporateCreditBalance?: number ) => ({
	type: UPDATE_CART,
	cart,
	walletBalance,
	corporateCreditBalance,
});

export const updateCartItem = request => ({
	type: UPDATE_CART_ITEM,
	request
});

export function updateItem(dispatch, request: UpdateItemRequest) {
	const dataProvider = DataProvider(process.env.REACT_APP_WAREHOUSE_API || '');

	if(request.availableQuantity && request.availableQuantity < request.quantity) {
		show(dispatch, `${request.availableQuantity === 1 ? 'È disponibile solo' : 'Sono disponibili solo'} ${request.availableQuantity} ${request.localLabel}`);
		return Promise.resolve(null);
	}

	dispatch(updateCartItem(request));
	dispatch(incrementPendingRequestCounter());

	return dataProvider(`b2c/locker/selling-order/edit-item`, {
		method: 'POST',
		body: JSON.stringify(request)
	})
	.then(data => {
		dispatch(update(data, request.walletBalance, request.corporateCreditBalance));
		dispatch(decrementPendingRequestCounter());
	})
	.catch(e => {
		show(dispatch, translateError(e.message));
		dispatch(decrementPendingRequestCounter());
		dispatch(updateStatus(SellingAreaStatus.FETCH_DATA))
	})
}

interface UpdateItemRequest {
	lockerId: number | string,
	itemSaleableId?: number, 
	itemSaleablePriceListId?: number,
	quantity: number,
	localPrice: number,
	localLabel: string;
	availableQuantity?: number,
	walletBalance: number,
	corporateCreditBalance: number,
	upsellingId?: string;
	bundleId?: string;
}

export const overrideCartTotal = (payload: {
	totalWithTax: number;
	walletBalance: number;
	corporateCreditBalance: number;
}) => ({
	type: OVERRIDE_CART_TOTAL,
	...payload,
});

interface ReloadCartRequest {

}